import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
import { DEMO_AI_REPORT_MARKDOWN } from "security-app/components/Investigations/AIReport/hooks/demoCannedReport";
import useAIReportDemoConfig from "security-app/components/Investigations/AIReport/hooks/useAIReportDemoConfig";
const urlPrefix = "/plugins/org.graylog.plugins.securityapp.investigations/investigations/summary";
const fetchAIReport = (investigationId) => fetch("GET", qualifyUrl(`${urlPrefix}/${investigationId}`)).then(
  (report) => report == null ? void 0 : report.text
);
const useAiReport = (investigationId, enabled) => {
  const { demoInvestigationId } = useAIReportDemoConfig();
  const isDemoInvestigation = !!demoInvestigationId && investigationId === demoInvestigationId;
  const { data, isLoading, isFetching, isSuccess, isFetched, isError, error } = useQuery({
    queryKey: ["investigation-ai-report", investigationId],
    queryFn: () => defaultOnError(
      fetchAIReport(investigationId),
      "Fetching AI Report failed with status",
      "Could not fetch AI Report"
    ),
    enabled: enabled && !isDemoInvestigation
  });
  if (isDemoInvestigation) {
    return {
      data: DEMO_AI_REPORT_MARKDOWN,
      isLoading: false,
      isFetching: false,
      isSuccess: true,
      isFetched: true,
      isError: false,
      error: void 0
    };
  }
  return {
    data,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isError,
    error
  };
};
export default useAiReport;
